// @flow

import gql from 'graphql-tag';

const appOverviewQuery = gql`
  query appOverviewQuery($slug: String!) {
    appBySlug(slug: $slug) {
      description
      id
      image
      name
      primaryColor
      slug
      url: externalUrl
      learnMoreUrl

      partnerStatus {
        tier
      }

      categories {
        id
        name
      }
    }
  }
`;

export default appOverviewQuery;
